import { useNavigate } from "react-router-dom";
import { LoginState, useLogin } from "../context";

export const Error = () => {
  const { loginState, error } = useLogin();
  const navigate = useNavigate();

  if (loginState !== LoginState.INVALID) return <></>;

  return (
    <>
      <h1 className={"nhsuk-u-font-size-32"} style={{ marginBottom: "16px" }}>
        Error
      </h1>
      <p className={"nhsuk-u-font-size-19"}>{error}</p>
      <p>
        Go back to the <a
          href="#"
          onClick={() => {
            navigate("/login");
          }}
        >login</a> screen
      </p>
    </>
  );
};
